import { render, staticRenderFns } from "./WorkflowChatAgentPanel.vue?vue&type=template&id=659648a9&scoped=true"
import script from "./WorkflowChatAgentPanel.vue?vue&type=script&lang=js"
export * from "./WorkflowChatAgentPanel.vue?vue&type=script&lang=js"
import style0 from "./WorkflowChatAgentPanel.vue?vue&type=style&index=0&id=659648a9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659648a9",
  null
  
)

export default component.exports